import { SELECTED_STAFF_MEMBER } from "../constants";

export const selectStaffMember = (memberData) => ({
  type: SELECTED_STAFF_MEMBER,
  payload: memberData,
});